import { IntlShape } from 'react-intl';
import { exportMessages } from 'components/ExportOrArchiveDialog/messages';
import { VendorDataType } from 'pages/VendorsTablePage/components/VendorsTable/types';
import { formatCurrency } from 'utils';
import type { ExportParamsType } from '../PdfExport/types';
import type {
  TableHeaderFiltersType,
  TotalsFooterType
} from 'components/ComposedTable/types';

const convertGridDataToCSV = (
  gridData: VendorDataType[],
  headerContent: string,
  footerContent: string
): string => {
  const headers = [
    '"Vendor No"',
    '"Vendor Name"',
    '"Payment Method"',
    '"Invoice No."',
    '"Amount ($)"',
    '"Discount ($)"',
    '"Net Payment ($)"',
    '"Invoice Date"',
    '"Due Date"',
    '"Hold"'
  ];

  const rows = gridData.flatMap(vendor =>
    vendor.invoices.map(invoice =>
      [
        `"${vendor.vendorNo}"`,
        `"${vendor.vendorName}"`,
        `"${vendor.paymentMethod}"`,
        `"${invoice.invoiceId}"`,
        `"${invoice.amount}"`,
        `"${invoice.discountAmount}"`,
        `"${invoice.netAmount}"`,
        `"${invoice.invoiceDate || ''}"`,
        `"${invoice.dueDate || ''}"`,
        `"${invoice.onHold ? 'Yes' : 'No'}"`
      ].join(',')
    )
  );

  return [headerContent, headers.join(','), ...rows, footerContent].join('\n');
};

export const getHeaderContent = (
  intl: IntlShape,
  tableHeaderFilters?: TableHeaderFiltersType
): string => {
  const { store, documentTitle, dueOnOrBefore, paymentMethod } = exportMessages;
  return `"${intl.formatMessage(store)}: ${
    tableHeaderFilters?.selectedStore || ''
  }"," "," "," "," "," "," "," "," "," "
"${intl.formatMessage(documentTitle)}: ${String(
    tableHeaderFilters?.tableTitle
  )}"
"${intl.formatMessage(dueOnOrBefore)}: ${
    tableHeaderFilters?.selectedDueDate || ''
  }"
"${intl.formatMessage(paymentMethod)}: ${
    tableHeaderFilters?.selectedPaymentMethods || ''
  }"`;
};

export const getFooterContent = (
  intl: IntlShape,
  totalsInFooter: TotalsFooterType | undefined
): string => `"${intl.formatMessage(exportMessages.discount)}: ${formatCurrency(
  totalsInFooter?.discountTotalInFooter
)}"
"${intl.formatMessage(exportMessages.totalOwed)}: ${formatCurrency(
  totalsInFooter?.totalOwedInFooter
)}"`;

export const generateCSVDocument = (
  gridData: VendorDataType[],
  { intl, totalsInFooter, tableHeaderFilters }: ExportParamsType
): string => {
  const headerContent = getHeaderContent(intl, tableHeaderFilters);
  const footerContent = getFooterContent(intl, totalsInFooter);
  return convertGridDataToCSV(gridData, headerContent, footerContent);
};
